<template>
  <div class="FichePortraitIndexTextuel">
    <page v-for="(page, index) in pages" :key="index" :format="'A3'">
      <page-inner>
        <fiche class="fiche-container ProjectTextIndex__fiche-container">
          <FichePortraitIndexTextuelCommon
            :date="date"
            :key="index"
            :index="index + 1"
            :title="title"
            :titlesecond="titlesecond"
            :total="pages.length"
          >
            <tr v-for="p in page" :key="p.uuid">
              <td>
                <p>
                  <span class="text-bold">{{ p.name }}</span>
                </p>
              </td>
              <td>
                <p>
                  {{ sortProgrammes(p.programs.map(p => p.name)).join(" ") }}
                </p>
              </td>
              <td>
                <p>
                  <span>{{ p.city }}&nbsp;({{ p.zipcode.slice(0, 2) }})</span>
                </p>
              </td>
              <td>
                <p>
                  <span v-if="getLatestDate(p)"
                    ><span class="text-light">{{ getLatestDate(p).text }}</span>
                    {{ extractYear(getLatestDate(p).content) }}</span
                  >
                </p>
              </td>
              <td></td>
              <td>
                <p>
                  <span v-if="getMaitrise(p)">{{
                    getMaitrise(p).join(", ")
                  }}</span>
                </p>
              </td>
              <td>
                <p>
                  {{
                    getArchitectes(p)
                      .map(p => filterScalene(p))
                      .join(", ")
                  }}
                </p>
              </td>
              <td>
                <p>{{ p.procedures.map(p => p.name).join(" ") }}</p>
              </td>
              <td>
                <p>
                  <span v-if="p.surfaces.length > 0"
                    >{{ formatNumbers(getBiggestSurface(p).content) }}m²</span
                  >
                </p>
              </td>
              <td>
                <p>
                  <span v-if="p.cost">{{ formatNumbersFrench(p.cost) }}€</span>
                </p>
              </td>
              <svg width="100%" height="1px">
                <path
                  style="fill:none;fill-opacity:1;stroke:#31287c;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 0,0 H 5000"
                />
              </svg>
            </tr>
            <tr class="sweepMark">
              <svg width="100%" height="1px">
                <path
                  style="fill:none;fill-opacity:1;stroke:#31287c;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 0,0 H 5000"
                />
              </svg>
            </tr>
          </FichePortraitIndexTextuelCommon>
        </fiche>
      </page-inner>
    </page>
  </div>
</template>

<script>
import Fiche from "../../../../PrintComponents/Fiche/Fiche";
import PageInner from "../../../../PrintComponents/Page/PageInner";
import {
  extractYear,
  filterScalene,
  formatNumbers,
  formatNumbersFrench,
  getEntrNamesBySlugMatching,
  mapNames,
  sortProgrammes
} from "../../../../../../util/func";
import FichePortraitIndexTextuelCommon from "./FichePortraitIndexTextuelCommonLarge";
import Page from "../../../../PrintComponents/Page/Page";

export default {
  name: "FichePortraitIndexTextuel",
  components: {
    Page,
    FichePortraitIndexTextuelCommon,
    Fiche,
    PageInner
  },
  data() {
    return {
      pages: []
    };
  },
  computed: {
    ratio() {
      return this.$store.state.drawing.ratio;
    },
    date() {
      return new Date().toLocaleDateString();
    }
  },
  props: {
    format: {},
    projets: {},
    index: {},
    title: {},
    titlesecond: {},
    p: {},
    pm: {},
    cols: {}
  },
  methods: {
    async layProjects() {
      this.pages = [];
      let pageIndex = 0;
      this.pages.push([]);
      let p = this.projets.slice(0);
      while (p.length > 0) {
        this.pages[pageIndex].push(p.shift());
        await new Promise(r => setTimeout(r, 16));
        const pageInside = document.querySelectorAll(".PPage .fiche-container")[
          pageIndex
        ];
        const sweepMark = document.querySelectorAll(
          ".PPage .fiche-container .sweepMark"
        )[pageIndex];
        if (
          this.overflows(
            pageInside.getBoundingClientRect(),
            sweepMark.getBoundingClientRect()
          )
        ) {
          const overflowing = this.pages[pageIndex].pop();
          this.pages.push([overflowing]);
          this.$root.$emit("DRAWING_SPACE_MOVED", this.pages.length);
          pageIndex += 1;
        }
        await new Promise(r => setTimeout(r, 16));
        this.$root.$emit("DRAWING_SPACE_MOVED", this.pages.length);
      }
      this.$emit("pages", this.pages.length);
    },
    overflows(a, b) {
      return a.y + a.height <= b.y + b.height;
    },
    mapNames,
    filterScalene,
    formatNumbersFrench,
    formatNumbers,
    extractYear,
    sortProgrammes,
    getArchitectes(project) {
      return getEntrNamesBySlugMatching("architecte", project.interlocuteurs_d);
    },
    getAmenageurs(project) {
      return getEntrNamesBySlugMatching("amenageur", project.interlocuteurs_d);
    },
    getMaitrise(project) {
      return getEntrNamesBySlugMatching("maitre", project.interlocuteurs_d);
    },
    getUser(project) {
      return getEntrNamesBySlugMatching(
        "utilisateur",
        project.interlocuteurs_d
      );
    },
    getLatestDate(project) {
      if (project.dates_d.length === 0) return false;
      const b = project.dates_d
        .slice(0)
        .sort((b, a) => (b.content > a.content ? -1 : 1))[0];
      return b;
    },
    getBiggestSurface(project) {
      if (project.surfaces.length === 0) return false;
      const b = project.surfaces
        .slice(0)
        .sort((b, a) => (b.content > a.content ? -1 : 1))[0];
      return b;
    }
  },
  mounted() {
    this.layProjects();
  },
  watch: {
    projets() {
      this.layProjects();
    },
    title(val, old) {
      if (val.length === 0 || old.length === 0) this.layProjects();
    },
    titlesecond(val, old) {
      if (val.length === 0 || old.length === 0) this.layProjects();
    }
  }
};
</script>
